import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button
} from "@material-ui/core"
import React, { FunctionComponent } from "react"
import { LoadingButton } from "./LoadingButton"

interface ConfirmationDialogProps {
    open: boolean
    onClose: () => void
    onConfirm: () => void
    title?: string
    contentText?: string
    loading?: boolean
}

export const ConfirmationDialog: FunctionComponent<ConfirmationDialogProps> = props => {
    const { open, onClose, title, contentText, onConfirm, loading } = props
    return (
        <Dialog data-testid="confirmation-dialog" open={open} onClose={onClose}>
            {title && <DialogTitle data-testid="dialog-title">{title}</DialogTitle>}
            <DialogContent>
                {contentText && (
                    <DialogContentText data-testid="dialog-content-text">
                        {contentText}
                    </DialogContentText>
                )}
            </DialogContent>
            <DialogActions>
                <Button data-testid="dialog-close-btn" onClick={onClose}>
                    Close
                </Button>
                <LoadingButton
                    buttonId="dialog-confirm-btn"
                    text="Confirm"
                    loading={loading ?? false}
                    disabled={false}
                    onClick={onConfirm}
                />
            </DialogActions>
        </Dialog>
    )
}
